import Icon from 'antd/lib/icon';
import * as React from 'react';
const TrailerModeSvg = ({ strokeColor, fill, ...rest }) => {
  return (
    <svg
      {...rest}
      width="24px"
      height="18px"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g strokeWidth={0.8} stroke={strokeColor} fillRule="evenodd" clipRule="evenodd" fill={fill || '#666'}>
        <path
          d="M24,14.2c0-0.4-0.3-0.6-0.5-0.8l0-2.8c0-0.1,0-0.3-0.1-0.4l-1.9-3.7c-0.1-0.3-0.4-0.5-0.7-0.5h-4.3
		c-0.4,0-0.8,0.3-0.8,0.8v6.5H7c-0.4-0.2-0.8-0.3-1.3-0.3v0c-0.5,0-0.9,0.1-1.3,0.3H0.8c-0.4,0-0.8,0.3-0.8,0.8V16
		c0,0.4,0.3,0.8,0.8,0.8H3c0.1,0.5,0.4,0.9,0.7,1.2c0.8,0.8,1.9,1,2.9,0.7c0.9-0.3,1.6-1,1.9-2h7.3c0.1,0.5,0.4,0.9,0.7,1.2
		c0.6,0.6,1.3,0.8,2,0.8c0.3,0,0.6,0,0.9-0.1c0.9-0.3,1.6-1,1.9-2h1.8c0.4,0,0.8-0.3,0.8-0.8L24,14.2z M8.4,14.9l7.5,0
		c0,0.1-0.1,0.2-0.1,0.3H8.5C8.5,15.1,8.5,15,8.4,14.9z M4.4,16c0-0.7,0.4-1.1,0.8-1.2c0.2-0.1,0.3-0.1,0.5-0.1
		c0.3,0,0.6,0.1,0.9,0.4h0c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.4,1c-0.5,0.5-1.1,0.5-1.5,0.3C4.8,17,4.4,16.6,4.4,16z M3,14.9
		C3,15,3,15.1,3,15.2H1.5v-0.3H3z M22.4,14.5l0,0.8h-1.1c-0.3-1.2-1.5-2.1-2.8-2.1h0c-0.5,0-0.9,0.1-1.3,0.3l0-5.5
		c0-0.1,0.1-0.2,0.2-0.2h2.6c0.1,0,0.2,0.1,0.3,0.2l1.5,2.8c0,0.1,0.1,0.1,0.1,0.2v2.8C22,14,22.2,14.3,22.4,14.5z M17.3,16
		c0-0.7,0.4-1.1,0.8-1.2c0.2-0.1,0.3-0.1,0.5-0.1c0.3,0,0.6,0.1,0.9,0.4c0.5,0.5,0.5,1.4,0,1.9c-0.5,0.5-1.1,0.5-1.5,0.3
		C17.7,17,17.3,16.6,17.3,16z"
        />
        <path d="M18.1,8.9v2.8c0,0.2,0.1,0.3,0.3,0.3h2.7V11l-1-2.3c0-0.1-0.1-0.2-0.3-0.2h-1.4C18.2,8.6,18.1,8.7,18.1,8.9z" />
      </g>
    </svg>
  );
};

const TrailerModeIconBlack = (props) => (
  <Icon
    component={(innerProps) => {
      return TrailerModeSvg(Object.assign({}, innerProps, props));
    }}
  ></Icon>
);
export default TrailerModeIconBlack;
